// extracted by mini-css-extract-plugin
export var productImage = "_ra-1";
export var viewLink = "_ra-2";
export var wishlistItem = "_ra-0";